var components
try {
  components = {
    uIcon: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-icon/u-icon" */ "uview-ui/components/u-icon/u-icon.vue"
      )
    },
  }
} catch (e) {
  if (
    e.message.indexOf("Cannot find module") !== -1 &&
    e.message.indexOf(".vue") !== -1
  ) {
    console.error(e.message)
    console.error("1. 排查组件名称拼写是否正确")
    console.error(
      "2. 排查组件是否符合 easycom 规范，文档：https://uniapp.dcloud.net.cn/collocation/pages?id=easycom"
    )
    console.error(
      "3. 若组件不符合 easycom 规范，需手动引入，并在 components 中注册该组件"
    )
  } else {
    throw e
  }
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var l0 = _vm.__map(_vm.options, function (item, index) {
    var $orig = _vm.__get_orig(item)
    var s0 = _vm.__get_style([
      {
        backgroundColor:
          item.style && item.style.backgroundColor
            ? item.style.backgroundColor
            : "#C7C6CD",
        borderRadius:
          item.style && item.style.borderRadius ? item.style.borderRadius : "0",
        padding: item.style && item.style.borderRadius ? "0" : "0 15px",
      },
      item.style,
    ])
    var a0 = item.icon
      ? {
          marginRight: item.text ? "2px" : 0,
        }
      : null
    var g0 = item.icon && item.iconSize ? _vm.$u.addUnit(item.iconSize) : null
    var g1 =
      item.icon && !item.iconSize && item.style && item.style.fontSize
        ? _vm.$u.getPx(item.style.fontSize)
        : null
    return {
      $orig: $orig,
      s0: s0,
      a0: a0,
      g0: g0,
      g1: g1,
    }
  })
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        l0: l0,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }